import React from 'react';
import firebase from '../../firebase';
import { connect } from 'react-redux';
import { setCurrentChannel, setPrivateChannel } from '../../actions';
import { Menu, Icon, Modal, Form, Input, Button, Label } from 'semantic-ui-react';

class Channels extends React.Component {

  // Initial State
  state = {
    activeChannel: "",
    user: this.props.currentUser,
    channel: null, 
    channels: [], 
    validChannels:[],
    channelName: "", 
    channelDetails: "", 
    channelLink :'',
    channelsRef: firebase.database().ref("channels"), 
    messagesRef: firebase.database().ref("messages"), 
    notifications: [], 
    modal: false,
    joinChannelModal: false,
    firstLoad: true,
    errors : ''
  };

  // React Lifecycle Methods
  componentDidMount() {
    this.addListeners();
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  // Listens from Firebase and adds channels to the app
  addListeners = () => {

    let loadedChannels = [];
    let loadedValidChannels = [];

    this.state.channelsRef.on("child_added", snap => {

      loadedChannels.push(snap.val());
      this.setState({ channels: loadedChannels }, () => this.setFirstChannel());
      this.addNotificationListener(snap.key);

      let value= snap.val();
      if(value.createdBy.id === this.state.user.uid){
        loadedValidChannels.push(snap.val());
        this.setState({ validChannels: loadedValidChannels }, () => this.setFirstChannel());
      }
     

    });

  };

  // Handles Channel Notifications and sets the state accordingly
  addNotificationListener = channelId => {
    this.state.messagesRef.child(channelId).on('value', snap => {
      if (this.state.channel) {
        this.handleNotifications(channelId, this.state.channel.id, this.state.notifications, snap);
      }
    });
  }

  handleNotifications = (channelId, currentChannelId, notifications, snap) => {
    let lastTotal = 0;

    let index = notifications.findIndex(
      notification => notification.id === channelId
    );

    if (index !== -1) {
      if (channelId !== currentChannelId) {
        lastTotal = notifications[index].total;

        if (snap.numChildren() - lastTotal > 0) {
          notifications[index].count = snap.numChildren() - lastTotal;
        }
      }
      notifications[index].lastKnownTotal = snap.numChildren();
    } else {
      notifications.push({
        id: channelId,
        total: snap.numChildren(),
        lastKnownTotal: snap.numChildren(),
        count: 0
      });
    }

    this.setState({ notifications });
  };

  removeListeners = () => {
    this.state.channelsRef.off();
    this.state.channels.forEach(channel => {
      this.state.messagesRef.child(channel.id).off();
    });
  };

  setFirstChannel = () => {

    let newarr = this.state.validChannels;
  
    const firstChannel = newarr[0];
    if (this.state.firstLoad && this.state.validChannels.length > 0) {
      this.props.setCurrentChannel(firstChannel);
      this.setActiveChannel(firstChannel);
      this.setState({ channel: firstChannel });
      this.setState({ firstLoad: false });
    }
  };

  addCurrentUserToChannel = (channel) => {
    const { channels, channelLink, user } = this.state;
    const users = channel.users ? channel.users : [];
    users.push(user.uid);
    var db = firebase.database();
    db.ref("channels/"+channel.id).update({ users: users });
    this.setState({ channelLink: ''});
    this.closeJoinChannelModal();
    let loadedChannels = [];
    this.state.channelsRef.on("child_added", snap => {
      loadedChannels.push(snap.val());
      this.setState({ channels: loadedChannels }, () => this.setFirstChannel());
      this.addNotificationListener(snap.key);
    });
  }
  
  addChannel = () => {

    const { channelsRef, channelName, channelDetails, user } = this.state;

    const key = channelsRef.push().key;

    const newChannel = {
      id: key,
      name: channelName,
      details: channelDetails,
      createdBy: {
        name: user.displayName,
        avatar: user.photoURL,
        // *** Added ID ***
        id : user.uid
      },
      joinUrl : "pulsechatapp/channel/join/" + Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10)
      
    };
    channelsRef
      .child(key)
      .update(newChannel)
      .then(() => {
        this.setState({ channelName: '', channelDetails: '' });
        this.closeModal();
      })
      .catch(err => {
        console.log(err);
      })
  }

  handleSubmit = event => {
    event.preventDefault();

    let result = this.isFormValid(this.state);
    if(result.length < 1) {
      this.addChannel();
    }else{
      this.setState( {"errors" : result});
    }
 };

 handleJoinChannelSubmit = event => {
  event.preventDefault();
  let data = this.isJoinChannelLinkValid(this.state);
  if(data.channelInfo) {
    this.addCurrentUserToChannel(data.channelInfo);
  }else{
    if(data.error.length > 1){
      this.setState( {"errors" : data.error});
    }else{
      this.setState( {"errors" : "Invalid URL"});
    }
  }
};

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // Changes Channel if public or private
  changeChannel = channel => {
    this.setActiveChannel(channel);
    this.clearNotifications();
    this.props.setCurrentChannel(channel);
    this.props.setPrivateChannel(false);
    this.setState({ channel });
  };

  // When Notified Channel is clicked this triggers
  clearNotifications = () => {
    let index = this.state.notifications.findIndex(
      notification => notification.id === this.state.channel.id
    );

    if (index !== -1) {
      let updatedNotifications = [...this.state.notifications];
      updatedNotifications[index].total = this.state.notifications[
        index
      ].lastKnownTotal;
      updatedNotifications[index].count = 0;
      this.setState({ notifications: updatedNotifications });
    }
  };

  setActiveChannel = channel => {
    this.setState({ activeChannel: channel.id });
  }

  getNotificationCount = channel => {
    let count = 0;

    this.state.notifications.forEach(notification => {
      if (notification.id === channel.id) {
        count = notification.count;
      }
    });

    if (count > 0) return count;
  };


  countChannels = (channels,user) => {

    let x = 0;
    channels.length > 0 && channels.map(channel => {
      if(user.uid === channel.createdBy.id || ( channel.users && (channel.users.indexOf(user.uid) > -1)))
        x++;
    })
    return x;
  }

  // Renders Channels to be displayed
  displayChannels = (channels,user) => (

    channels.length > 0 && channels.map(channel => {
      if(user.uid === channel.createdBy.id || ( channel.users && (channel.users.indexOf(user.uid) > -1)))
      return  <Menu.Item
        key = {channel.id}
        onClick = {() => this.changeChannel(channel)}
        name = {channel.name}
        style = {{ opacity: 0.7 }}
        active = { channel.id === this.state.activeChannel } >
        {this.getNotificationCount(channel) && (
          <Label color="red">{this.getNotificationCount(channel)}</Label>
        )}
        # {channel.name}

      </Menu.Item>
  
        })
  )

  // Only Valid Channels are added
  isFormValid = ({ channelName, channelDetails ,channels}) => {
    let error = '';
    if(channelName && channelDetails){
      channels.map((channel) => {
        if(channel.name == channelName){
          error = 'Duplicate Channel name';
        }
      });
    }else if(!channelName && !channelDetails){
      error = 'Name & Description are required.'
    }else if(!channelDetails){
      error = 'Description is required.'
    }else{
      error = 'Name is required.'
    }
    return error;
  };

  isJoinChannelLinkValid = ({ channelLink,channels,user }) =>{
    let data = {error : '', channelInfo : false};
    channels.length > 0 && channels.map(channel => {
      if(channelLink === channel.joinUrl){

        if(channel.users){
          if(channel.createdBy.id !== user.uid){
            if( channel.users.indexOf(user.uid) == -1){
              data.channelInfo = channel;
            }else{
              data.error = "You have already joined this channel";
            }
          }else{
            data.error = "You created this channel, already joined!";
          }
        }else{
          if(channel.createdBy.id !== user.uid){
            data.channelInfo = channel;
          }else{
            data.error  = "You have created this channel, alrady joined!!";
          }
        }
      }
    })

    return data;
  };

  openModal = () => this.setState({ modal: true, errors :'' });
  closeModal = () => this.setState({ modal: false });

  openJoinChannelModal = () => this.setState({ joinChannelModal: true, errors:"" });
  closeJoinChannelModal = () => this.setState({ joinChannelModal: false });

  // React Render method which uses Semantic UI React Components
  render() {

    const { channels, errors ,modal ,user,joinChannelModal} = this.state;

    return (

      <React.Fragment>
      <Menu.Menu className="menu">
        <Menu.Item>
          <span>
            <Icon name='random'/> Channels
          </span> {' '}
          ({this.countChannels(channels,user)}) 
          <Icon name='join' title="Join channel" onClick={this.openJoinChannelModal}/>
          <Icon title="Add channel" name='add' onClick={this.openModal}/>
        </Menu.Item>
        {this.displayChannels(channels,user)}
      </Menu.Menu>  {/*Anything after dot is child component of Menu. For e.g <Menu.Item> here Item is child of Menu*/}

      {/*Add Channels */}
      <Modal basic open={ modal } onClose={ this.closeModal }>
        <Modal.Header> Add a Channel </Modal.Header>
        <Modal.Content>
          <Form onSubmit={this.handleSubmit}>
            <Form.Field>
              <Input 
                fluid
                label="Name of Channel"
                name="channelName"
                onChange={this.handleChange}
              />
            </Form.Field>
            <Form.Field>
              <Input 
                fluid
                label="Description of Channel"
                name="channelDetails"
                onChange={this.handleChange}
              />
            </Form.Field>
            <span style={{"color":"#ff392b"}}>{errors}</span>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" inverted onClick={this.handleSubmit}>
            <Icon name="checkmark" /> Add
          </Button>
          <Button color="red" inverted onClick={this.closeModal}>
            <Icon name="remove" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
      {/*Join Channel*/}
       <Modal basic open={ joinChannelModal } onClose={ this.closeModal }>
        <Modal.Header> Join Channel </Modal.Header>
        <Modal.Content>
          <Form onSubmit={this.handleJoinChannelSubmit}>
            <Form.Field>
              <Input 
                fluid
                label="Link of channel"
                name="channelLink"
                onChange={this.handleChange}
              />
              <span style={{"color":"#ff392b"}}>{errors}</span>
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" inverted onClick={this.handleJoinChannelSubmit}>
            <Icon name="checkmark" /> Add
          </Button>
          <Button color="red" inverted onClick={this.closeJoinChannelModal}>
            <Icon name="remove" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
      </React.Fragment>
    );
  }
}

export default connect(null, { setCurrentChannel, setPrivateChannel })(Channels);